var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickerHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "#DFE7C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73242 14.625V12.525C2.73242 12.3472 2.76367 12.1778 2.82617 12.0166C2.88867 11.8555 2.98867 11.7062 3.12617 11.5687L9.14492 5.54995L8.13242 4.5562L9.08867 3.59995L10.4387 4.94995L12.5053 2.88333C12.5609 2.8277 12.6304 2.78326 12.7136 2.75001C12.797 2.71664 12.8887 2.69995 12.9887 2.69995C13.0887 2.69995 13.1824 2.71558 13.2699 2.74683C13.3574 2.77808 13.4324 2.82495 13.4949 2.88745L15.1262 4.53745C15.183 4.61033 15.2285 4.68933 15.2625 4.77445C15.2966 4.85945 15.3137 4.95058 15.3137 5.04783C15.3137 5.14508 15.297 5.23533 15.2638 5.31858C15.2304 5.40183 15.186 5.4712 15.1305 5.5267L13.0824 7.57495L14.4324 8.9437L13.4762 9.89995L12.4637 8.88745L6.46367 14.9062C6.32617 15.0437 6.17686 15.1437 6.01573 15.2062C5.85461 15.2687 5.68517 15.3 5.50742 15.3H3.40742C3.21617 15.3 3.05586 15.2353 2.92648 15.1059C2.79711 14.9765 2.73242 14.8162 2.73242 14.625ZM4.08242 13.95H5.50742L11.5074 7.94995L10.1012 6.52495L4.08242 12.525V13.95ZM12.0324 6.7312L13.7199 5.02495L13.0074 4.2937L11.3012 5.9812L12.0324 6.7312Z",
    fill: "#2D3245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickerHover);
export default __webpack_public_path__ + "static/media/Picker-Hover.6f7acf160e371e97c62314714a457ff4.svg";
export { ForwardRef as ReactComponent };